import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { layoutContentMaxWidthPx } from '../../../../shared/style-settings'

export const useMainPageStepsSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(11),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
      },
    },
    inner: {
      maxWidth: layoutContentMaxWidthPx,
      margin: '0 auto',
    },
  })
)
